import styled from 'styled-components';

import { Button } from '../Button';

export const SliderContainerCustom = styled.div`
  position: relative;
`;

export const SliderButton = styled(Button)`
  --width: 1.5rem;
  user-select: none;
  position: absolute;
  z-index: 2;
  top: calc(50% - var(--width)/2);
  opacity: 0.4;
  padding: 0;
  width: var(--width);
  height: var(--width);
  border-radius: var(--width);
  font-size: calc(var(--width) / 1.5);
  transition: opacity .25s cubic-bezier(.17,.67,.83,.67), color .5s cubic-bezier(.17,.67,.83,.67);
  ${({ anchor }) => (anchor ? `${anchor}:10px` : '')};
  &.disabled {
    display: none;
  }
`;
